import { Step } from 'react-joyride';

// Steps for the main reports list page
export const reportsListSteps: Step[] = [
  {
    target: '[data-tour="generate-report-button"]',
    content: 'To generate a new performance report, enter your website URL and click this button. We\'ll analyze your site and provide detailed insights.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="report-usage"]',
    content: 'This section shows your current usage stats and remaining credits. Keep track of how many reports you\'ve generated this month.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="reports-list"]',
    content: 'All your generated reports appear here. Each report contains detailed performance metrics, Core Web Vitals, and actionable recommendations.',
    placement: 'top',
  },
  {
    target: '[data-tour="view-all-reports-link"]',
    content: 'Now let\'s explore the AI Solutions page where you can get intelligent recommendations to fix the issues found in your reports.',
    placement: 'right',
  },
];

// Steps for individual report view page
export const reportsSteps: Step[] = [
  {
    target: 'body',
    content: 'Welcome to your PageSpeed Performance Report! This comprehensive analysis shows how your website performs and provides actionable insights to improve loading speed and user experience.',
    placement: 'center',
  },
  {
    target: '[data-tour="report-header"]',
    content: 'This header shows key information about your report: the tested URL, analysis date, device type, and provides actions like regenerating, sharing, or printing the report.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="performance-score"]',
    content: 'Your overall performance score is displayed here. Scores range from 0-100: Poor (0-49), Needs Improvement (50-89), and Good (90-100). This score is based on Core Web Vitals and other performance metrics.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="core-web-vitals"]',
    content: 'These are your Core Web Vitals - the key metrics Google uses to measure user experience. Click any metric to jump directly to actionable insights for that specific area.',
    placement: 'left',
  },
  {
    target: '[data-tour="metrics-overview"]',
    content: 'This section provides a detailed breakdown of your site\'s performance, showing metrics that need attention versus those performing well. Look for the red cards - these indicate areas needing immediate attention.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="actionable-insights"]',
    content: 'Here you\'ll find detailed, actionable recommendations organized by Core Web Vitals. Each insight shows the potential performance savings and affected resources.',
    placement: 'top',
    spotlightPadding: 10,
  },
  {
    target: '[data-tour="high-priority-fixes"]',
    content: 'Perfect! These High Impact Priority Fixes show the most critical performance issues. Click on any of these accordion buttons to expand and see detailed recommendations for fixing that specific issue.',
    placement: 'bottom',
    spotlightPadding: 10,
  },
  {
    target: 'body',
    content: 'Task Creation Workflow: When you click on any insight above, it will expand to show detailed information and a "Create High Priority Task" button. Click that button to add the insight to your task queue.',
    placement: 'center',
  },
  {
    target: 'body',
    content: 'Task Queue Management: After creating tasks, a Task Queue panel will appear at the bottom-right. From there, you can review your queued tasks and use "Create 1 Task" to finalize them into your project management system.',
    placement: 'center',
  },
  {
    target: '[data-tour="visualizations"]',
    content: 'The visualizations section shows performance charts, resource budgets, and filmstrip analysis. These help you understand how your page loads and where optimization opportunities exist.',
    placement: 'top',
    spotlightPadding: 10,
  },
  {
    target: 'body',
    content: 'You\'re now ready to optimize your website! Remember: Focus on high-impact fixes first, create tasks for systematic tracking, and use the AI assistance to get detailed implementation guidance. Happy optimizing!',
    placement: 'center',
  },
];
